/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Org Document Ingest API
 * API for handling organization document ingestion and processing
 * OpenAPI spec version: 1.0.0
 */
import { customIngestInstance } from '../api/IngestAxiosInstance';
/**
 * Response model when an approval workflow has been started via Temporal.
 */
export interface ApprovalStartedResult {
  workflow_id: string;
  base_doc_id: string;
  message?: string;
}

export type ChunkReadOrgCategory = typeof ChunkReadOrgCategory[keyof typeof ChunkReadOrgCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChunkReadOrgCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

export interface ChunkRead {
  org_category: ChunkReadOrgCategory;
  org_id: string;
  doc_id: string;
  doc_name: string;
  doc_source: string;
  doc_tags: string[];
  chunk_id: string;
  chunk_index: string;
  chunk_text: string;
}

export interface CleanupResponse {
  cleaned_doc_ids: string[];
  message: string;
}

export type DocVersionStatus = typeof DocVersionStatus[keyof typeof DocVersionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocVersionStatus = {
  draft: 'draft',
  pending_review: 'pending_review',
  activating: 'activating',
  active: 'active',
  superseded: 'superseded',
  rejected: 'rejected',
  failed: 'failed',
} as const;

/**
 * Which stored representation of a document a caller wants to address.

ORIGINAL is the uploaded file as it arrived; MARKDOWN is the extracted-markdown
companion blob written by ingestion. Both exist after a FULL run, so this is a
separate axis from ProcessingMode rather than a mirror of it.
 */
export type DocumentVariant = typeof DocumentVariant[keyof typeof DocumentVariant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentVariant = {
  original: 'original',
  markdown: 'markdown',
} as const;

export type GeneratedUploadUrlCategory = typeof GeneratedUploadUrlCategory[keyof typeof GeneratedUploadUrlCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GeneratedUploadUrlCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

export interface GeneratedUploadUrl {
  id: string;
  category: GeneratedUploadUrlCategory;
  upload_url: string;
  doc_id: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

/**
 * A single format available for a legislation version (e.g. XML, PDF).
 */
export interface LegislationVersionFormat {
  type: string;
  url: string;
}

export type LegislationWorkLegislationType = string | null;

export type LegislationWorkLegislationStatus = string | null;

export type LegislationWorkLatestMatchingVersion = LegislationWorkVersionSummary | null;

/**
 * A single legislation work returned from GET /v0/works/ on the NZ Legislation API.
 */
export interface LegislationWork {
  work_id: string;
  legislation_type?: LegislationWorkLegislationType;
  legislation_status?: LegislationWorkLegislationStatus;
  latest_matching_version?: LegislationWorkLatestMatchingVersion;
}

/**
 * Condensed version info nested in a work search result (latest_matching_version).
 */
export interface LegislationWorkVersionSummary {
  title: string;
  version_id: string;
  is_latest_version: boolean;
  formats?: LegislationVersionFormat[];
}

/**
 * Paginated response from GET /v0/works/ on the NZ Legislation API.
 */
export interface LegislationWorksResponse {
  results?: LegislationWork[];
  page?: number;
  per_page?: number;
  total?: number;
}

export interface LiveHealthyResponse {
  status_kind?: 'healthy';
  version: string;
}

export interface LiveUnhealthyResponse {
  status_kind?: 'unhealthy';
  version: string;
  failures: string[];
}

export interface NotReadyResponse {
  status_kind?: 'not_ready';
  version: string;
  dependencies: string[];
}

export type OrgDocumentOrgCategory = typeof OrgDocumentOrgCategory[keyof typeof OrgDocumentOrgCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgDocumentOrgCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

export type OrgDocumentDocLastCataloguedAt = string | null;

export type OrgDocumentDocLastMarkdownCreatedAt = string | null;

export type OrgDocumentDocLastProcessedAt = string | null;

export type OrgDocumentDocLastIndexedAt = string | null;

export type OrgDocumentProcessingError = string | null;

export type OrgDocumentSourceId = string | null;

export type OrgDocumentSourceVersion = string | null;

export type OrgDocumentSourceEffectiveDate = string | null;

export type OrgDocumentSourceExpiryDate = string | null;

export type OrgDocumentEmbeddingModel = string | null;

export type OrgDocumentEmbeddingDimensions = number | null;

export interface OrgDocument {
  org_category: OrgDocumentOrgCategory;
  org_id: string;
  doc_id: string;
  doc_name: string;
  doc_source: string;
  doc_tags: string[];
  doc_last_catalogued_at?: OrgDocumentDocLastCataloguedAt;
  doc_last_markdown_created_at?: OrgDocumentDocLastMarkdownCreatedAt;
  doc_last_processed_at?: OrgDocumentDocLastProcessedAt;
  doc_last_indexed_at?: OrgDocumentDocLastIndexedAt;
  processing_status?: ProcessingStatus;
  processing_error?: OrgDocumentProcessingError;
  source_id?: OrgDocumentSourceId;
  source_version?: OrgDocumentSourceVersion;
  source_effective_date?: OrgDocumentSourceEffectiveDate;
  source_expiry_date?: OrgDocumentSourceExpiryDate;
  embedding_model?: OrgDocumentEmbeddingModel;
  embedding_dimensions?: OrgDocumentEmbeddingDimensions;
  doc_version?: number;
  doc_version_status?: DocVersionStatus;
}

/**
 * How much of the ingestion pipeline to run for a document.

FULL runs the whole pipeline (markdown + chunk + embed + index); MARKDOWN_ONLY
stops after persisting the markdown, leaving any existing chunks in place.
 */
export type ProcessingMode = typeof ProcessingMode[keyof typeof ProcessingMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessingMode = {
  full: 'full',
  markdown_only: 'markdown_only',
} as const;

export interface ProcessingResponse {
  status: string;
  message: string;
}

export type ProcessingStatus = typeof ProcessingStatus[keyof typeof ProcessingStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProcessingStatus = {
  pending: 'pending',
  processing: 'processing',
  completed: 'completed',
  failed: 'failed',
  deleting: 'deleting',
  cleaning: 'cleaning',
} as const;

export interface ReadyResponse {
  status_kind?: 'ready';
  version: string;
}

/**
 * Response model for a successful version rejection.
 */
export interface RejectionResult {
  rejected_doc_id: string;
  version: number;
  chunks_deleted: number;
}

export type SourceSourceUrl = string | null;

export type SourceLegislationWorkId = string | null;

export type SourceLegislationVersionId = string | null;

export type SourceLastCheckedAt = string | null;

export type SourceLastChangedAt = string | null;

export type SourceNextCheckAt = string | null;

export type SourceSourceVersion = string | null;

export type SourceSourceEffectiveDate = string | null;

export type SourceOrgCategory = typeof SourceOrgCategory[keyof typeof SourceOrgCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceOrgCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

export interface Source {
  source_id?: string;
  source_type: SourceType;
  source_name: string;
  source_url?: SourceSourceUrl;
  legislation_work_id?: SourceLegislationWorkId;
  legislation_version_id?: SourceLegislationVersionId;
  /** @minimum 1 */
  poll_interval_hours?: number;
  last_checked_at?: SourceLastCheckedAt;
  last_changed_at?: SourceLastChangedAt;
  next_check_at?: SourceNextCheckAt;
  source_version?: SourceSourceVersion;
  source_effective_date?: SourceSourceEffectiveDate;
  source_status?: SourceStatus;
  org_category: SourceOrgCategory;
  org_id: string;
}

export type SourceCreateSourceUrl = string | null;

export type SourceCreateLegislationWorkId = string | null;

export type SourceCreateLegislationVersionId = string | null;

export type SourceCreateOrgCategory = typeof SourceCreateOrgCategory[keyof typeof SourceCreateOrgCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceCreateOrgCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

export interface SourceCreate {
  source_type: SourceType;
  source_name: string;
  source_url?: SourceCreateSourceUrl;
  legislation_work_id?: SourceCreateLegislationWorkId;
  legislation_version_id?: SourceCreateLegislationVersionId;
  /** @minimum 1 */
  poll_interval_hours?: number;
  source_status?: SourceStatus;
  org_category: SourceCreateOrgCategory;
  org_id: string;
}

export type SourceStatus = typeof SourceStatus[keyof typeof SourceStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceStatus = {
  active: 'active',
  paused: 'paused',
  stale: 'stale',
  retired: 'retired',
  error: 'error',
} as const;

export type SourceType = typeof SourceType[keyof typeof SourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceType = {
  legislation_nz_pco: 'legislation_nz_pco',
  http_etag: 'http_etag',
  manual: 'manual',
} as const;

export type SourceUpdateSourceUrl = string | null;

export type SourceUpdateLegislationWorkId = string | null;

export type SourceUpdateLegislationVersionId = string | null;

export type SourceUpdateOrgCategory = typeof SourceUpdateOrgCategory[keyof typeof SourceUpdateOrgCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceUpdateOrgCategory = {
  public: 'public',
  internal: 'internal',
  personal: 'personal',
} as const;

/**
 * Admin-mutable fields for updating a source. Excludes system-managed timestamps.
 */
export interface SourceUpdate {
  source_id: string;
  source_type: SourceType;
  source_name: string;
  source_url?: SourceUpdateSourceUrl;
  legislation_work_id?: SourceUpdateLegislationWorkId;
  legislation_version_id?: SourceUpdateLegislationVersionId;
  /** @minimum 1 */
  poll_interval_hours?: number;
  source_status?: SourceStatus;
  org_category: SourceUpdateOrgCategory;
  org_id: string;
}

export type ValidationErrorLocItem = string | number;

export type ValidationErrorCtx = { [key: string]: unknown };

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
  input?: unknown;
  ctx?: ValidationErrorCtx;
}

export type VersionInfoDocLastProcessedAt = string | null;

export type VersionInfoSourceVersion = string | null;

export type VersionInfoSourceEffectiveDate = string | null;

/**
 * Summary model for listing document versions.
 */
export interface VersionInfo {
  versioned_doc_id: string;
  base_doc_id: string;
  version: number;
  doc_version_status: DocVersionStatus;
  doc_name: string;
  doc_last_processed_at?: VersionInfoDocLastProcessedAt;
  source_version?: VersionInfoSourceVersion;
  source_effective_date?: VersionInfoSourceEffectiveDate;
}

export type GetLiveness200 = LiveHealthyResponse | LiveUnhealthyResponse;

export type GetReadiness200 = ReadyResponse | NotReadyResponse;

export type ProcessUploadedDocumentParams = {
/**
 * Store the document without deriving anything from it: no markdown, no chunks, no embeddings. Takes precedence over processing_mode, which must then be omitted or 'full'.
 */
skip_processing?: boolean;
/**
 * How much of the pipeline to run. 'full' extracts markdown, then chunks, embeds and indexes. 'markdown_only' stops after persisting the markdown and leaves any existing chunks untouched. Ignored when skip_processing=true, which is why combining it with 'markdown_only' is rejected.
 */
processing_mode?: ProcessingMode;
};

export type GetDocumentDownloadUrlParams = {
/**
 * Which stored representation to link to. 'original' is the uploaded file. 'markdown' is the extracted-markdown companion written by ingestion, and returns 404 for documents that have never had markdown extracted.
 */
variant?: DocumentVariant;
};

export type SearchLegislationWorksParams = {
/**
 * Elasticsearch search query for legislation works
 */
search_term?: string | null;
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Results per page (max 100)
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};

export type GetSourceParams = {
org_id: string;
};

export type UpdateSourceParams = {
org_id: string;
};

export type DeleteSourceParams = {
org_id: string;
};

export type ListSourcesParams = {
org_id: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getOrgDocumentIngestAPI = () => {
/**
 * Liveness probe - checks if the application is running.
Rate limited to prevent DoS attacks.
 * @summary Liveness
 */
const getLiveness = (
    
 options?: SecondParameter<typeof customIngestInstance<GetLiveness200>>,) => {
      return customIngestInstance<GetLiveness200>(
      {url: `/api/v1/health/live`, method: 'GET'
    },
      options);
    }
  
/**
 * Readiness probe - checks if the application can handle requests.
Rate limited to prevent DoS attacks.
 * @summary Readiness
 */
const getReadiness = (
    
 options?: SecondParameter<typeof customIngestInstance<GetReadiness200>>,) => {
      return customIngestInstance<GetReadiness200>(
      {url: `/api/v1/health/ready`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Generate Upload Url
 */
const generateUploadUrl = (
    orgDocument: OrgDocument,
 options?: SecondParameter<typeof customIngestInstance<GeneratedUploadUrl>>,) => {
      return customIngestInstance<GeneratedUploadUrl>(
      {url: `/api/v1/org_document/ingest/upload_url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgDocument
    },
      options);
    }
  
/**
 * Start background processing for a document already uploaded to blob storage. Returns as soon as the work is queued, so a `processing` status means accepted, not finished — poll `listDocumentsByOrg` for the resulting timestamps.

`processing_mode=markdown_only` extracts and stores the markdown companion blob without chunking, embedding or indexing, leaving any existing chunks in place. Read the result with `getDocumentDownloadUrl?variant=markdown`.
 * @summary Process an uploaded document
 */
const processUploadedDocument = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
    params?: ProcessUploadedDocumentParams,
 options?: SecondParameter<typeof customIngestInstance<ProcessingResponse>>,) => {
      return customIngestInstance<ProcessingResponse>(
      {url: `/api/v1/org_document/ingest/process/${orgCategory}/${orgId}/${docId}`, method: 'POST',
        params
    },
      options);
    }
  
/**
 * @summary Delete Document
 */
const deleteDocument = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
 options?: SecondParameter<typeof customIngestInstance<ProcessingResponse>>,) => {
      return customIngestInstance<ProcessingResponse>(
      {url: `/api/v1/org_document/ingest/delete/${orgCategory}/${orgId}/${docId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Cleanup Stale Documents
 */
const cleanupStaleDocuments = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
 options?: SecondParameter<typeof customIngestInstance<CleanupResponse>>,) => {
      return customIngestInstance<CleanupResponse>(
      {url: `/api/v1/org_document/ingest/cleanup/${orgCategory}/${orgId}`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary List Documents By Org
 */
const listDocumentsByOrg = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
 options?: SecondParameter<typeof customIngestInstance<OrgDocument[]>>,) => {
      return customIngestInstance<OrgDocument[]>(
      {url: `/api/v1/org_document/list/${orgCategory}/${orgId}`, method: 'GET'
    },
      options);
    }
  
/**
 * Returns a read-only SAS URL valid for one hour. Use `variant` to choose which stored representation to link to: the uploaded file, or the extracted-markdown companion written by ingestion.

The URL is minted without contacting storage, so an `original` link is not proof the blob exists. For `markdown` the catalog is checked first, which is why that variant can return 404.
 * @summary Get a short-lived download URL for a document
 */
const getDocumentDownloadUrl = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
    params?: GetDocumentDownloadUrlParams,
 options?: SecondParameter<typeof customIngestInstance<string>>,) => {
      return customIngestInstance<string>(
      {url: `/api/v1/org_document/download_url/${orgCategory}/${orgId}/${docId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get Chunk
 */
const getChunk = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
    chunkId: string,
 options?: SecondParameter<typeof customIngestInstance<ChunkRead>>,) => {
      return customIngestInstance<ChunkRead>(
      {url: `/api/v1/org_document/chunk/${orgCategory}/${orgId}/${docId}/${chunkId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Create Source
 */
const createSource = (
    sourceCreate: SourceCreate,
 options?: SecondParameter<typeof customIngestInstance<Source>>,) => {
      return customIngestInstance<Source>(
      {url: `/api/v1/source_registry/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sourceCreate
    },
      options);
    }
  
/**
 * @summary Search Legislation Works
 */
const searchLegislationWorks = (
    params?: SearchLegislationWorksParams,
 options?: SecondParameter<typeof customIngestInstance<LegislationWorksResponse>>,) => {
      return customIngestInstance<LegislationWorksResponse>(
      {url: `/api/v1/source_registry/legislation/works`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get Source
 */
const getSource = (
    orgCategory: 'public' | 'internal' | 'personal',
    sourceId: string,
    params: GetSourceParams,
 options?: SecondParameter<typeof customIngestInstance<Source>>,) => {
      return customIngestInstance<Source>(
      {url: `/api/v1/source_registry/${orgCategory}/${sourceId}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update Source
 */
const updateSource = (
    orgCategory: 'public' | 'internal' | 'personal',
    sourceId: string,
    sourceUpdate: SourceUpdate,
    params: UpdateSourceParams,
 options?: SecondParameter<typeof customIngestInstance<Source>>,) => {
      return customIngestInstance<Source>(
      {url: `/api/v1/source_registry/${orgCategory}/${sourceId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sourceUpdate,
        params
    },
      options);
    }
  
/**
 * @summary Delete Source
 */
const deleteSource = (
    orgCategory: 'public' | 'internal' | 'personal',
    sourceId: string,
    params: DeleteSourceParams,
 options?: SecondParameter<typeof customIngestInstance<void>>,) => {
      return customIngestInstance<void>(
      {url: `/api/v1/source_registry/${orgCategory}/${sourceId}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary List Sources
 */
const listSources = (
    orgCategory: 'public' | 'internal' | 'personal',
    params: ListSourcesParams,
 options?: SecondParameter<typeof customIngestInstance<Source[]>>,) => {
      return customIngestInstance<Source[]>(
      {url: `/api/v1/source_registry/${orgCategory}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Approve Version
 */
const approveDocumentVersion = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
 options?: SecondParameter<typeof customIngestInstance<ApprovalStartedResult>>,) => {
      return customIngestInstance<ApprovalStartedResult>(
      {url: `/api/v1/document-ingest/versions/${orgCategory}/${orgId}/${docId}/approve`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Reject Version
 */
const rejectDocumentVersion = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
 options?: SecondParameter<typeof customIngestInstance<RejectionResult>>,) => {
      return customIngestInstance<RejectionResult>(
      {url: `/api/v1/document-ingest/versions/${orgCategory}/${orgId}/${docId}/reject`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary List Versions
 */
const listDocumentVersions = (
    orgCategory: 'public' | 'internal' | 'personal',
    orgId: string,
    docId: string,
 options?: SecondParameter<typeof customIngestInstance<VersionInfo[]>>,) => {
      return customIngestInstance<VersionInfo[]>(
      {url: `/api/v1/document-ingest/versions/${orgCategory}/${orgId}/${docId}`, method: 'GET'
    },
      options);
    }
  
return {getLiveness,getReadiness,generateUploadUrl,processUploadedDocument,deleteDocument,cleanupStaleDocuments,listDocumentsByOrg,getDocumentDownloadUrl,getChunk,createSource,searchLegislationWorks,getSource,updateSource,deleteSource,listSources,approveDocumentVersion,rejectDocumentVersion,listDocumentVersions}};
export type GetLivenessResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['getLiveness']>>>
export type GetReadinessResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['getReadiness']>>>
export type GenerateUploadUrlResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['generateUploadUrl']>>>
export type ProcessUploadedDocumentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['processUploadedDocument']>>>
export type DeleteDocumentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['deleteDocument']>>>
export type CleanupStaleDocumentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['cleanupStaleDocuments']>>>
export type ListDocumentsByOrgResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['listDocumentsByOrg']>>>
export type GetDocumentDownloadUrlResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['getDocumentDownloadUrl']>>>
export type GetChunkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['getChunk']>>>
export type CreateSourceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['createSource']>>>
export type SearchLegislationWorksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['searchLegislationWorks']>>>
export type GetSourceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['getSource']>>>
export type UpdateSourceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['updateSource']>>>
export type DeleteSourceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['deleteSource']>>>
export type ListSourcesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['listSources']>>>
export type ApproveDocumentVersionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['approveDocumentVersion']>>>
export type RejectDocumentVersionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['rejectDocumentVersion']>>>
export type ListDocumentVersionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOrgDocumentIngestAPI>['listDocumentVersions']>>>
